import { ComponentType } from 'react'
import * as cn from 'classnames'
import * as styles from 'styles/ShadedLoadable.css'
import Spinner from 'components/features/pfm/Spinner/Spinner'
import Loadable from 'components/Loadable'

class ShadedLoadable<TComponentProps> extends Loadable<TComponentProps> {
  render () {
    // It is TS bug, I should declare types explicitly
    const Content: ComponentType<TComponentProps> = this.props.content
    const isShadedShown = true
      && !this.state.isLoaded
      && Boolean(this.state.lastComponentsProps)

    return (
      <div className={ cn(styles.shadedLoadable, { [styles.isShown]: isShadedShown }) }>
        { this.state.lastComponentsProps && <Content { ...this.state.lastComponentsProps } /> }
        { this.state.lastComponentsProps ? this.renderSpinner() : this.renderPreloader() }
      </div>
    )
  }

  renderSpinner () {
    if (this.state.isLoaded) {
      return null
    }

    return (
      <div className={ styles.overlay }>
        <Spinner />
      </div>
    )
  }

  renderPreloader () {
    if (this.state.isLoaded) {
      return null
    }

    const Preloader: ComponentType<{}> | false = this.props.preloader

    if (!Preloader) {
      throw 'Preloader is required prop for ShadedLoadable!'
    }

    return (
      <Preloader />
    )
  }
}


export default ShadedLoadable
